<template><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <rect width="14" height="14" fill="none"/>
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <path d="M639.755,1618.574a.824.824,0,0,1,.824-.824h10.712a.824.824,0,0,1,.824.824v6.592a.824.824,0,0,1-.824.824H640.579a.824.824,0,0,1-.824-.824Z"
              transform="translate(-639.005 -1614.028)"/>
        <path d="M651.449,1615.722a2.472,2.472,0,1,0-4.944,0" transform="translate(-642.047 -1612)"/>
        <path d="M639.755,1623.75h5.356" transform="translate(-639.005 -1616.732)"/>
        <path d="M652.505,1623.75h5.356" transform="translate(-644.751 -1616.732)"/>
        <path d="M650.329,1623.972a.824.824,0,0,1-.824-.824v-.824a.824.824,0,1,1,1.648,0v.824A.824.824,0,0,1,650.329,1623.972Z"
              transform="translate(-643.399 -1615.718)"/>
    </g>
</svg>
</template>